<template>
  <div class="etapas configuracoes mt-3" :value="idPublicacao" :controlePage="controlePage">
    <div class="row">
      <div class="col-sm-12 textConfiguracoes">
        A configuração deste item está relacionado diretamente a conta onde o pagamento será
        creditado. Após cadastrar as informações, emita boleto de teste, o pagamento e identifique
        se o pagamento caiu na conta certa.
      </div>
    </div>
    <hr />
    <div class="row innerPage">
      <div class="col-sm-6">
        <label>Selecione a conta para geração de Boletos</label>
        <fcc-select
          class="mb-4"
          placeholder="Selecione uma conta"
          labelField="nomebeneficiario"
          v-model="contaBancaria"
          :options="listagemContas"
          required
          :disabled="
            controlePage.idsituacao === 4 ||
            (!pix && controlePage.contabancaria != null) ||
            (pix && controlePage.contabancariapix != null)
          "
          @change="alteraConta"
          :clearable="false"
        >
          Banco
        </fcc-select>
      </div>
      <div class="col-sm-6 plusConta">
        <button
          v-if="contaBancaria == null"
          v-b-tooltip.hover
          title="Adicionar Conta"
          @click="addField"
          class="btn btn-light border shadow-sm ml-2 text-dark"
        >
          <font-awesome-icon icon="plus" />
        </button>
        <button
          v-if="controlePage.idsituacao != 4 && contaBancaria != null"
          v-b-tooltip.hover
          :title="controlePage.idsituacao != 4 ? 'Editar Conta' : 'Ver Conta'"
          @click="
            controlePage.idsituacao != 4 ? editField(contaBancaria) : editField(contaBancaria, true)
          "
          class="btn btn-light border shadow-sm ml-2 text-dark"
        >
          <font-awesome-icon :icon="controlePage.idsituacao != 4 ? 'edit' : 'eye'" />
        </button>
        <template v-if="controlePage.idsituacao != 4 && contaBancaria != null">
          <button
            v-b-tooltip.hover
            title="Gerar Código Boleto"
            @click="gerarBoleto"
            class="btn btn-light border shadow-sm ml-2 text-dark"
          >
            <font-awesome-icon icon="file" />
          </button>
        </template>
        <template v-if="controlePage.idsituacao != 4 && contaBancaria != null">
          <button
            v-b-tooltip.hover
            title="Desvincular Conta"
            @click="clearField"
            class="btn btn-light border shadow-sm ml-2 text-dark"
          >
            <font-awesome-icon icon="eraser" />
          </button>
        </template>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12"></div>
    </div>
    <fccModal
      centered
      size="xl"
      idModal="addFieldModalConta"
      titleModal="Nova Conta Bancária"
      escondeFooter
      travaEsc
      travaBack
    >
      <form
        autocomplete="off"
        @submit.prevent="criar.idcontabancaria === 0 ? addCnpj() : editarCnpj()"
      >
        <div class="etapas configuracoes">
          <div class="borderForm innerPage">
            <div class="row my-3">
              <div class="col-sm-3">
                <fccInput
                  :disabled="criar.idcontabancaria > 0 || desabilitaInput"
                  extraClasses="inputLabel"
                  required
                  minlength="14"
                  v-model="criar.cnpjbeneficiario"
                  v-mask="cnpjMask"
                  >CNPJ<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-9">
                <fccInput
                  :disabled="desabilitaInput"
                  extraClasses="inputLabel"
                  required
                  v-model="criar.nomebeneficiario"
                  >Beneficiario<span>*</span></fccInput
                >
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-3">
                <fccInput
                  :disabled="desabilitaInput"
                  extraClasses="inputLabel"
                  v-model="criar.descricao"
                  >Descrição<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-9">
                <fccInput
                  :disabled="desabilitaInput"
                  extraClasses="inputLabel"
                  v-model="criar.textoapresentacao"
                  >Texto Apresentação<span>*</span></fccInput
                >
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-6">
                <fcc-select
                  class="mb-4"
                  placeholder="Selecione um Banco"
                  labelField="banco"
                  valueField="id"
                  v-model="criar.idbanco"
                  :options="lstBancos"
                  required
                  @change="changeBancos"
                  :clearable="false"
                >
                  Banco
                </fcc-select>
              </div>
              <div class="col-sm-6">
                <fcc-select
                  class="mb-4"
                  placeholder="Selecione um tipo de pagamento"
                  labelField="tipopagamento"
                  valueField="id"
                  v-model="criar.idtipopagamento"
                  :options="lstFormaPagamento"
                  :disabled="tipopagamento != null"
                  required
                  :clearable="false"
                >
                  Tipo Acesso
                </fcc-select>
              </div>
              <div class="col-sm-6" v-if="pix">
                <fccInput
                  :disabled="criar.idcontabancaria > 0 || desabilitaInput"
                  extraClasses="inputLabel"
                  required
                  type="number"
                  v-model="criar.expires"
                  >Pix - Tempo para expirar<span>*</span></fccInput
                >
              </div>
            </div>
            <template v-if="pix">
              <div class="row">
                <div class="col-sm-6">
                  <fccInput
                    :disabled="criar.idcontabancaria > 0 || desabilitaInput"
                    extraClasses="inputLabel"
                    required
                    v-model="criar.pixKey"
                    >PIX Key<span>*</span></fccInput
                  >
                </div>

                <div class="col-sm-6">
                  <fccInput
                    :disabled="criar.idcontabancaria > 0 || desabilitaInput"
                    extraClasses="inputLabel"
                    required
                    v-model="criar.payerMessage"
                    >PIX - Mensagem de cobrança<span>*</span></fccInput
                  >
                </div>
              </div>
            </template>
            <div class="row my-3">
              <div class="col-sm-3">
                <fccInput
                  :disabled="criar.idcontabancaria > 0 || desabilitaInput"
                  extraClasses="inputLabel"
                  required
                  v-model="criar.agencia"
                  >Agência<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-3">
                <fccInput
                  :disabled="criar.idcontabancaria > 0 || desabilitaInput"
                  extraClasses="inputLabel"
                  required
                  v-model="criar.digitoagencia"
                  >Digito<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-3">
                <fccInput
                  :disabled="criar.idcontabancaria > 0 || desabilitaInput"
                  extraClasses="inputLabel"
                  required
                  v-model="criar.contabeneficiario"
                  >Conta<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-3">
                <fccInput
                  :disabled="criar.idcontabancaria > 0 || desabilitaInput"
                  extraClasses="inputLabel"
                  required
                  v-model="criar.digitocontabeneficiario"
                  >Digito<span>*</span></fccInput
                >
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-3">
                <fccInput
                  :disabled="criar.idcontabancaria > 0 || desabilitaInput"
                  extraClasses="inputLabel"
                  v-model="criar.carteira"
                  >Carteira<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-3">
                <fccInput extraClasses="inputLabel" v-model="criar.variacaocarteira"
                  >Variação carteira<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-3">
                <fccInput
                  :disabled="criar.idcontabancaria > 0 || desabilitaInput"
                  extraClasses="inputLabel"
                  v-model="criar.numeroconvenio"
                  >Nº de Convênio<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-3">
                <fccInput
                  :disabled="criar.idcontabancaria > 0 || desabilitaInput"
                  extraClasses="inputLabel"
                  v-model="criar.numerocomercioeletronico"
                  >Nº Comércio eletrônico<span>*</span></fccInput
                >
              </div>
            </div>

            <div class="row my-3">
              <div class="col-sm-6">
                <fccInput extraClasses="inputLabel" v-model="criar.clientid">Client Id</fccInput>
              </div>

              <div class="col-sm-6">
                <fccInput extraClasses="inputLabel" v-model="criar.clientsecret"
                  >Client Secret</fccInput
                >
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-sm-12">
                <fccInput extraClasses="inputLabel" v-model="criar.basictoken"
                  >Basic Token</fccInput
                >
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-sm-6">
                <fccInput extraClasses="inputLabel" v-model="criar.applicationkey"
                  >Application Key</fccInput
                >
              </div>
              <div class="col-sm-6">
                <div class="pt-1">
                  <toggle-button v-model="criar.pix" :sync="true" /> Pix no concurso?
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-sm-4">
                <fccInput extraClasses="inputLabel" v-model="criar.granttype">Grant Type</fccInput>
              </div>
              <div class="col-sm-4">
                <fccInput extraClasses="inputLabel" v-model="criar.userName">Username</fccInput>
              </div>
              <div class="col-sm-4">
                <fccInput extraClasses="inputLabel" v-model="criar.password">Password</fccInput>
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-12">
                <fccInput
                  :disabled="desabilitaInput"
                  extraClasses="inputLabel"
                  required
                  v-model="criar.localpagamento"
                  >Local de pagamento<span>*</span></fccInput
                >
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-3">
                <fccInput
                  :disabled="desabilitaInput"
                  extraClasses="inputLabel"
                  required
                  @change="buscandoEndereco()"
                  v-mask="cepMask"
                  v-model="criar.cep"
                  >CEP<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-6">
                <fccInput
                  :disabled="desabilitaInput"
                  extraClasses="inputLabel"
                  required
                  v-model="criar.logradouro"
                  >Endereço<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-3">
                <fccInput
                  :disabled="desabilitaInput"
                  extraClasses="inputLabel"
                  required
                  v-model="criar.numero"
                  >Número<span>*</span></fccInput
                >
              </div>
            </div>
            <div class="row my-12">
              <div class="col-sm-12">
                <fccInput
                  :disabled="desabilitaInput"
                  extraClasses="inputLabel"
                  v-model="criar.complemento"
                  >Complemento<span>*</span></fccInput
                >
              </div>
            </div>
            <div class="row my-3">
              <div class="col-sm-4">
                <fccInput
                  :disabled="desabilitaInput"
                  extraClasses="inputLabel"
                  required
                  v-model="criar.bairro"
                  >Bairro<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-5">
                <fccInput
                  :disabled="desabilitaInput"
                  extraClasses="inputLabel"
                  required
                  v-model="criar.cidade"
                  >Cidade<span>*</span></fccInput
                >
              </div>
              <div class="col-sm-3">
                <fccInput
                  :disabled="desabilitaInput"
                  extraClasses="inputLabel"
                  required
                  v-model="criar.uf"
                  >UF<span>*</span></fccInput
                >
              </div>
            </div>
            <div class="row my-3 buttonSalvar">
              <div class="col-sm-12 text-right">
                <fccButton tipo="submit" :disabled="desabilitaInput"
                  ><font-awesome-icon icon="save" /> {{ labelsSystem.salvar }}</fccButton
                >
              </div>
            </div>
          </div>
        </div>
      </form>
    </fccModal>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'

export default {
  data() {
    return {
      editar: {
        idcontabancaria: 0,
        idpublicacao: this.controlePage.idpublicacao,
        idpublicacaocontabancaria: this.idContaPublicacao
      },
      desabilitaInput: false,
      criar: {},
      textoPublicacao: 'Configurações da Publicação',
      tipoPublicacao: this.controlePage.idpublictipo,
      name: 'Selecione uma conta',
      listagemContas: [],
      listarEndereco: [],
      lstBancos: [],
      idContaPublicacao: '',
      contaBancaria: null
    }
  },
  methods: {
    alteraConta() {
      this.pix
        ? this.$emit('alteraTipoPix', this.contaBancaria.idcontabancaria, this.contaBancaria)
        : this.$emit('alteraTipoPagamento', this.contaBancaria.idcontabancaria, this.contaBancaria)
    },
    changeBancos(recebe) {
      this.criar.numerobanco = recebe.codigo
      this.criar.nomebanco = recebe.banco
    },
    listandoContas() {
      axios
        .get(
          this.baseUrlPublicacao + 'ContaBancaria/ListarContaBancaria',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listagemContas = response.data
          this.listagemContas = this.listagemContas.filter(
            (conta) => conta.idtipopagamento === this.tipopagamento.id
          )

          this.contaBancaria = this.pix
            ? this.controlePage.contabancariapix
            : this.controlePage.contabancaria
        })
        .catch(this.setErrorSystem)
    },
    addField() {
      this.criar.idcontabancaria = 0
      this.$root.$emit('bv::show::modal', 'addFieldModalConta')
    },
    editField(contaBancaria, disabled = false) {
      this.criar = contaBancaria
      this.desabilitaInput = disabled
      this.$root.$emit('bv::show::modal', 'addFieldModalConta')
    },
    gerarBoleto() {
      this.callConfirm('Deseja gerar o CdBoleto ', 'da spi ' + this.controlePage.spi + ' ?').then(
        (result) => {
          if (result.value) {
            this.gerarCdBoletoPublicacao(this.idPublicacao).then(() => {
              this.callToast(this.mensagensUpdate.adicionado)
            })
          }
        }
      )
    },
    clearField() {
      this.callConfirm(
        'Deseja desvincular a conta ',
        'da spi ' + this.controlePage.spi + ' ?'
      ).then((result) => {
        if (result.value) {
          this.pix
            ? this.$emit('alteraTipoPix', 0, null)
            : this.$emit('alteraTipoPagamento', 0, null)
        }
      })
    },
    editarCnpj() {
      this.criar.cnpjbeneficiario = this.removeAcento(this.criar.cnpjbeneficiario)
      this.criar.cep = this.removeAcento(this.criar.cep)
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .put(
          this.baseUrlPublicacao + 'ContaBancaria/AlterarContaBancaria',
          this.criar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() => {
          this.listandoContas()
          this.carregaTexto()
          this.$root.$emit('bv::hide::modal', 'addFieldModalConta')
          this.callToast(this.mensagensUpdate.editado)
        })
        .catch((error) => {
          this.setErrorSystem(error)
          this.carregaTexto()
        })
    },
    addCnpj() {
      this.criar.srcimg = ''
      this.criar.url = ''
      this.criar.idpublicacao = 0
      this.criar.idpublicacaocontabancaria = 0
      this.criar.flGerarArquivoRemessa = true
      this.criar.flGerarArqBaixa = true
      this.criar.complemento = this.criar.complemento == null ? '' : this.criar.complemento
      this.criar.cnpjbeneficiario = this.removeAcento(this.criar.cnpjbeneficiario)

      this.criar.cep = this.removeAcento(this.criar.cep)
      this.carregaTexto(this.codeMensagem('C03'))
      axios
        .post(
          this.baseUrlPublicacao + 'ContaBancaria/InserirContaBancaria',
          this.criar,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((resposta) => {
          this.criar.idcontabancaria = resposta.data
          this.pix
            ? this.$emit('alteraTipoPix', resposta.data, this.criar)
            : this.$emit('alteraTipoPagamento', resposta.data, this.criar)

          this.$root.$emit('bv::hide::modal', 'addFieldModalConta')

          setTimeout(() => {
            this.listandoContas()
            this.carregaTexto()
            this.$forceUpdate()
            this.callToast(this.mensagensUpdate.adicionado)
          }, 500)
        })
        .catch((error) => {
          this.$root.$emit('bv::hide::modal', 'addFieldModalConta')
          this.setErrorSystem(error)
          this.carregaTexto()
        })
    },
    listarBancos() {
      this.carregaTexto(this.codeMensagem('C01'))
      this.listarBancosGenerico().then((resposta) => {
        this.lstBancos = resposta
        if (this.tipopagamento.grucobranca) {
          this.lstBancos = this.lstBancos.filter(function (banco) {
            return banco.banco.indexOf('GRU COBRANÇA') != -1
          })
        } else {
          this.lstBancos = this.lstBancos.filter(function (banco) {
            return banco.banco.indexOf('GRU') == -1
          })
        }
        this.carregaTexto()
      })
    },
    buscandoEndereco: async function () {
      this.carregaTexto(this.codeMensagem('C01'))
      var cep = ''
      cep = await this.buscarEnderecoCep(this.criar.cep)
      if (cep !== 'CEP NAO ENCONTRADO') {
        this.criar.logradouro = cep.log_no
        this.criar.bairro = cep.bai_no
        this.criar.cidade = cep.loc_no
        this.criar.uf = cep.ufe_sg
        this.carregaTexto()
      } else {
        this.criar.logradouro = ''
        this.criar.bairro = ''
        this.criar.cidade = ''
        this.criar.uf = ''
        this.callAlert('CEP não encontrado', '', 'error')
        this.carregaTexto()
      }
      this.$forceUpdate()
    }
  },
  props: {
    idPublicacao: Number,
    controlePage: Object,
    lstFormaPagamento: Array,
    tipopagamento: Object,
    pix: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
    this.criar.idtipopagamento = this.tipopagamento.id
    this.listandoContas()
    this.listarBancos()
  }
}
</script>
